"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const FlightReverseIcon = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.33329 13L5.66663 13L8.99996 7.66671L12.6666 7.66671C13.22 7.66671 13.6666 7.22004 13.6666 6.66671C13.6666 6.11337 13.22 5.66671 12.6666 5.66671L8.99996 5.66671L5.66663 0.333374L4.33329 0.333374L5.99996 5.66671L2.33329 5.66671L1.33329 4.33337L0.333292 4.33337L0.999959 6.66671L0.333292 9.00004L1.33329 9.00004L2.33329 7.66671L5.99996 7.66671L4.33329 13Z",
    fill: "#75767A"
  }));
};
var _default = exports.default = FlightReverseIcon;